import type { ReactNode } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'
import { useScreenSizeUp } from 'hooks/useScreenSize'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import { INTL_DMY_CASUAL_SHORT_FORMAT } from 'constants/dateFormats'
import { ONE_POINT_PROMO_DATE, usePromoValues } from 'components/MaldivesDirect/OnePointPromo/promoContent'

const BannerWrap = styled.div`
  margin-inline: ${rem(-24)};
  padding: ${rem(12)} ${rem(20)};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  border: ${rem(1)} solid ${props => props.theme.palette.neutral.surface.lightForeground};

  &.flush {
    margin-inline: 0;
  }
`
const SaleText = styled.strong`
  color: ${props => props.theme.palette.messaging.urgency.normalForeground};
`
const fireIcon = <SolidFireIcon colour="urgency" />
const emphasis = (chunks: ReactNode) => <SaleText>{chunks}</SaleText>

interface Props {
  flush?: boolean
}

export default function MaldivesCharterOnePointCalendarBanner({ flush = false }: Props) {
  const intl = useIntl()
  const { fare } = usePromoValues()
  const isDesktop = useScreenSizeUp('desktop')
  return <BannerWrap className={flush ? 'flush' : undefined} data-testid="maldives-charter-one-point-calendar-banner">
    <BodyTextBlock variant={isDesktop ? 'medium' : 'small'} startIcon={fireIcon}>
      {intl.formatMessage({
        id: 'cyJ4HN1qfXrYCk8CT7u2',
        defaultMessage: '<sale>One-way flight for 1 Société Point + {fare} pp:</sale> One departure date only: {date}.',
      }, { sale: emphasis, fare, date: intlDateFormatter(ONE_POINT_PROMO_DATE, INTL_DMY_CASUAL_SHORT_FORMAT, intl.locale) })}
    </BodyTextBlock>
  </BannerWrap>
}
